import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 84EB4644-EC38-431B-B55B-12363EB63765
 * name bowl
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bowl.svg
 * tags
 * - Food / Drink 
 */
export const BowlIcon = createSvgIcon(<><path d="M22 15C22 18.9 18.9 22 15 22H9C5.1 22 2 18.9 2 15V12H22V15Z" /></>, 'BowlIcon');
export default BowlIcon